var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cpt-login_bg"},[_c('video',{staticClass:"login-bg_video",attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("@/assets/videos/bg.mp4"),"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }